import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * MetaPixel — SPA route-change PageView tracking for Meta Pixel ID 2003274333725911.
 * The base code in index.html fires the FIRST PageView on initial load; this
 * component fires a PageView on every subsequent client-side navigation so the
 * pixel sees the entire website correctly (SPAs don't reload pages).
 * Admin routes are excluded — we only measure customer-facing traffic.
 */
export default function MetaPixel() {
  const loc = useLocation();
  const firstRef = useRef(true);

  useEffect(() => {
    if (firstRef.current) {
      // Base code already fired PageView for the initial load.
      firstRef.current = false;
      return;
    }
    if (loc.pathname.startsWith("/admin")) return;
    try {
      if (typeof window.fbq === "function") {
        window.fbq("track", "PageView");
      }
    } catch { /* pixel blocked by ad-blocker — fine */ }
  }, [loc.pathname, loc.search]);

  return null;
}
